const getAttributeByLocale = (val, locale) => {
  return val?.[locale] || val?.en || '';
};

export default getAttributeByLocale;
